import classNames from 'classnames';
import { Button } from 'palette/Button';
import { Drawer } from 'palette/Drawer';
import { BodyText } from 'palette/Typography';
import { BEMBlock } from '@helpers/classnames';
import { DESKTOP_SEARCH_MODAL_ID } from '../constants';
import GlobalSearchFormContainer from '../containers/GlobalSearchFormContainer';
import GlobalSearchResultsContainer from '../containers/GlobalSearchResultsContainer';
import type { GlobalSearchResultsData } from '../types';
import '../styles/GlobalSearch.scss';

interface GlobalSearchProps {
    currentDepartment?: string;
    hasCloseButton?: boolean;
    header: string;
    inputRef: React.RefObject<HTMLInputElement>;
    isScreenTouched: boolean;
    redirectUrl: string;
    searchButtonRef: React.RefObject<HTMLButtonElement>;
    searchResults: GlobalSearchResultsData;
    searchTerm: string;
    suggestedQuery: string;
    onClick: () => void;
    onModalClose: () => void;
    onSearchTermChange: (value: string) => void;
    onTouchScreen: (state: boolean) => void;
}

function GlobalSearch({
    currentDepartment,
    hasCloseButton,
    header,
    inputRef,
    isScreenTouched,
    redirectUrl,
    searchButtonRef,
    searchResults,
    searchTerm,
    suggestedQuery,
    onClick,
    onModalClose,
    onSearchTermChange,
    onTouchScreen,
}: GlobalSearchProps) {
    const [block, BEMElement] = BEMBlock('global-search');

    return (
        <div className={classNames(block)}>
            <Button
                ref={searchButtonRef}
                isTransparent
                className={BEMElement('search-form')}
                iconColor="black"
                iconName="palette_search"
                iconPosition="left"
                theme="secondary"
                onClick={onClick}
            >
                <BodyText
                    className={BEMElement('header')}
                    color="regular"
                    level="2"
                >
                    {header}
                </BodyText>
            </Button>
            <Drawer
                anchor="right"
                className={BEMElement('drawer')}
                id={DESKTOP_SEARCH_MODAL_ID}
                modalBoxClassname={BEMElement('modal-box')}
                size="large"
                onClose={onModalClose}
            >
                <GlobalSearchFormContainer
                    currentDepartment={currentDepartment}
                    hasCloseButton={hasCloseButton}
                    inputRef={inputRef}
                    isScreenTouched={isScreenTouched}
                    redirectUrl={redirectUrl}
                    searchTerm={searchTerm}
                    suggestedQuery={suggestedQuery}
                    onSearchTermChange={onSearchTermChange}
                    onTouchScreen={onTouchScreen}
                />
                <GlobalSearchResultsContainer
                    searchResults={searchResults}
                    searchTerm={searchTerm}
                    onTouchScreen={onTouchScreen}
                />
            </Drawer>
        </div>
    );
}

export default GlobalSearch;
